import { render, staticRenderFns } from "./SegurArchives.vue?vue&type=template&id=575aac4e&scoped=true"
import script from "./SegurArchives.vue?vue&type=script&lang=js"
export * from "./SegurArchives.vue?vue&type=script&lang=js"
import style0 from "./SegurArchives.vue?vue&type=style&index=0&id=575aac4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575aac4e",
  null
  
)

export default component.exports